import { returnsApiProxy } from '@/redux/api/returnsApiSlice'
import type { ReturnsApiGetOrderRequest } from '@itsrever/rever-api'
import { useMutation } from '@tanstack/react-query'

const authenticateOrder = async ({
    ecommerceId,
    customerPrintedOrderId,
    email,
    userPreferredLang
}: ReturnsApiGetOrderRequest) => {
    const { data } = await returnsApiProxy.getOrder({
        ecommerceId,
        customerPrintedOrderId,
        email,
        userPreferredLang
    })

    return data
}

export const useAuthenticateOrder = () => {
    return useMutation({
        mutationFn: authenticateOrder
    })
}
